import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleWhatIsGTBuy from "../pages/article-what-is-gtbuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/what-is-gtbuy-spreadsheet",
    element: <ArticleWhatIsGTBuy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
